import ChequesState from "./chequesStates";

/**
 * Que se puede hacer con un cheque, por estado y por propio/tercero.
 *
 * Las reglas salen de CheckController, no de ChecksStates::ValidatePreviousState(): la constante
 * del backend dice otra cosa para negotiate, debit y anular, y lo que corta el pedido es el
 * controller. 'anular' no figura porque su metodo arranca con un throw "No implementado".
 *
 * Un propio En Cartera no ofrece nada: deposit no valida IsOwn(), pero GetMoneyAccountForState()
 * devuelve null para un propio Depositado y el movimiento de tesoreria quedaria roto.
 *
 * Los id son los que espera ModalChangeState, que los traduce al action del endpoint.
 */
const ACCIONES = {
  depositar: "Depositar cheque",
  cobrar_por_ventanilla: "Cobrar cheque por ventanilla",
  negotiate: "Negociar cheque",
  acreditar: "Acreditar cheque",
  debitar: "Debitar cheque",
  rechazar: "Rechazar cheque",
};

const POR_ESTADO = {
  terceros: {
    [ChequesState.STATE_EN_CARTERA]: ["depositar", "cobrar_por_ventanilla", "negotiate"],
    [ChequesState.STATE_DEPOSITADO]: ["acreditar"],
    // El rechazo revierte la acreditacion y luego rechaza: el banco primero acredita y despues debita
    [ChequesState.STATE_ACREDITED]: ["rechazar"],
  },
  propios: {
    [ChequesState.STATE_UTILIZADO]: ["debitar", "rechazar"],
  },
};

/** Acciones disponibles para un cheque, como [{ id, name }]. */
function accionesDe(state, is_own) {
  const ids = POR_ESTADO[is_own ? "propios" : "terceros"][state] || [];
  return ids.map((id) => ({ id: id, name: ACCIONES[id] }));
}

/** Titulo del modal de la accion. */
function nombreDe(id) {
  return ACCIONES[id] || "";
}

export default {
  accionesDe,
  nombreDe,
};
